import { Creator } from "./Checklist";
import { CompanyOffice } from "./CompanyOffice";

export type Company = {
  id: string;

  // Editable fields
  ueCode: string;
  name: string;
  orgNr: string;
  address: string;
  postalCode: string;
  city: string;
  email: string;
  phone: string;
  hourlyRate: number | null;
  contactName: string;
  bookingEmail: string;
  latitude: number;
  longitude: number;
  region: string;
  rating: number | null;
  ratingNotApplicable: boolean;
  folderUrl: string;
  kammarkollegietApproved: boolean;
  listedIn5620: boolean;
  competences: CompanyCompetence[];

  // Metadata
  state: CompanyState;
  onboardingState: OnboardingState;
  stateChangedAt: string | null;
  stateChangedBy: Creator | null;
  updatedAt: string | null;
  updatedBy: Creator | null;
  checkedAt: string | null;
  checkedBy: Creator | null;

  // Relations
  users: Creator[];
  offices: CompanyOffice[];
};

export type CompanyIdParam = {
  id: string;
};

export type CompanyState = "NEW" | "ACTIVE" | "ARCHIVED" | "BLOCKED";

export const CompanyStateValues: Record<CompanyState, string> = {
  NEW: "Ny",
  ACTIVE: "Aktiv",
  ARCHIVED: "Arkiverad",
  BLOCKED: "Blockerad",
};

export type OnboardingState = "NOT_CONTACTED" | "SUPPLIER_CERT_SENT" | "PENDING_APPROVAL";

export const OnboardingStateValues: Record<OnboardingState, string> = {
  NOT_CONTACTED: "Ej kontaktad",
  SUPPLIER_CERT_SENT: "Lev.cert skickat",
  PENDING_APPROVAL: "Väntar godkännande",
};

export type CompanyCompetence = "CRESTRON" | "EXTRON" | "DANTE" | "Q_SYS" | "LED" | "ELECTRICAL";

export const CompanyCompetenceValues: Record<CompanyCompetence, string> = {
  CRESTRON: "Crestron",
  EXTRON: "Extron",
  DANTE: "Dante",
  Q_SYS: "Q-Sys",
  LED: "LED",
  ELECTRICAL: "Elinstallation",
};
